import { TextBlock } from './TextBlock';
import { ErrorBlock } from './ErrorBlock';
import { JobBlock } from './job';
import { CandidateBlock } from './candidate';
import { ClarifyBlock } from './clarify';
import { ClarifyFormBlock } from './clarifyForm';
import { ResumeBlock } from './resume';
import { DataTableBlock } from './dataTable';
import { CandidateProfilesBlock } from './candidateProfiles';
import { EmailComposeBlock } from './emailCompose';
import type { BlockRegistry } from './registry.types';

// Maps a block `type` to its renderer. Each entry expects props of the shape
// `{ data: <variant data> }`. Phase 3 follow-ups append flow / file /
// entity / actionResult.
export const BLOCK_REGISTRY: BlockRegistry = {
  text: TextBlock,
  error: ErrorBlock,
  job: JobBlock,
  candidate: CandidateBlock,
  clarify: ClarifyBlock,
  clarifyForm: ClarifyFormBlock,
  resume: ResumeBlock,
  dataTable: DataTableBlock,
  candidateProfiles: CandidateProfilesBlock,
  emailCompose: EmailComposeBlock,
};
